import React from 'react';
import StoreSelect from '../../Forms/Store/StoreSelect.js';
import { FormControl } from '@mui/material';

const OrderBy = (props) => {
  const {
    value,
    onChange,
    availableTagsByGroupName
  } = props;

  const orderByOptions = [
    { id: 'id', name: 'published-date-newest-first' },
    { id: 'title', name: 'product-title-az' },
    { id: 'price', name: 'price-low-to-high' }
  ];

  // if there's author tags available, show 'order by author name' too
  if (availableTagsByGroupName &&
    availableTagsByGroupName.Author &&
    availableTagsByGroupName.Author.length) {
    orderByOptions.splice(2, 0, {
      id: 'author',
      name: 'author-surname-az'
    });
  }

  return (
    <FormControl size='small'>
      <StoreSelect
        value={value}
        options={orderByOptions}
        onChange={onChange}
      />
    </FormControl>
  );
};

export default OrderBy;
